import type { Types as SduiTypes } from '../types';
import type { OutTypes } from './schedules';

export default (
  course: SduiTypes.course
): OutTypes.course => {
  return {
    ids:         course.id,
    displayName: course.name,
    color:       course.color,
    teachers:    course.teachers.map(to => ({ to })),
    groups:      course.classes .map(to => ({ to })),
  };
};
